import mixpanel from 'mixpanel-browser';

import { AnalyticsProvider } from './types';

/**
 * Mixpanel implementation of AnalyticsProvider.
 *
 * To swap to a different vendor, create a new file implementing AnalyticsProvider
 * and replace this class in analyticsService.ts.
 */
export class MixpanelProvider implements AnalyticsProvider {
  private initialised = false;

  init(token: string): void {
    mixpanel.init(token, {
      track_pageview: false, // we handle page views manually
      persistence: 'localStorage',
      record_sessions_percent: 100,
      record_block_selector: '',
      record_mask_text_selector: '.sensitive',
      // Cap session replay duration to keep IndexedDB usage bounded.
      // Without these, a single replay can run up to 24h and accumulate
      // multi-hour idle gaps that look like bugs in playback. A 10 min idle
      // timeout absorbs normal "thinking pauses" while still ending replays
      // cleanly when the user walks away, and the 60 min hard cap prevents
      // any single replay from growing unbounded on long-lived tabs.
      record_idle_timeout_ms: 10 * 60 * 1000,
      record_max_ms: 60 * 60 * 1000
    });
    this.initialised = true;
  }

  identify(userId: string, traits?: Record<string, unknown>): void {
    if (!this.initialised) return;
    mixpanel.identify(userId);
    if (traits && Object.keys(traits).length > 0) {
      mixpanel.people.set(traits);
    }
  }

  track(event: string, properties?: Record<string, unknown>): void {
    if (!this.initialised) return;
    mixpanel.track(event, properties);
  }

  reset(): void {
    if (!this.initialised) return;
    mixpanel.reset();
  }
}
